import React from 'react';
import ContactFormTwo from '../components/ContactFormTwo';
import './Contact.css';
import { Helmet } from 'react-helmet';


function Contact() {
  return (
    <div className="contact-page">
        <Helmet>
        <link rel="canonical" href="https://marketingv8.co/contact" />
        <title>Marketing v8 - Contact</title>
        <meta name="description" content="Marketing v8 - Contact: Get in touch with us for AI and automation solutions" />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marketingv8.co/contact" />
        <meta property="og:title" content="Marketing v8 - Contact" />
        <meta property="og:description" content="Marketing v8 - Contact: Get in touch with us for AI and automation solutions" />
        <meta property="og:image" content="https://marketingv8.co/logov8.png" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Marketing v8 - Contact" />
        <meta name="twitter:description" content="Marketing v8 - Contact: Get in touch with us for AI and automation solutions" />
        <meta name="twitter:image" content="https://marketingv8.co/logov8.png" />
        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact Marketing v8",
          "url": "https://marketingv8.co/contact",
          "description": "Get in touch with Marketing v8 for AI and automation solutions"
        })}</script>
      </Helmet>
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get In Touch</h1>
          <p>Let's discuss how we can help grow your business</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Got a question, idea, or project? <br /> Drop us a line — we’d love to hear from you.</h2>
          <p>Whether you need a quick quote, help choosing the right service, or want to talk strategy, share a few details and we’ll come back with clear next steps — usually within one business day.</p>
          <div className="info-card">
            <h3>📧 Email</h3>
            <a href="mailto:office@marketingv8.co">office@marketingv8.co</a>
          </div>

          <div className="info-card">
            <h3>📞 Phone</h3>
            <a href="tel:+48535959510">+48 535 959 510</a>
            <p>Mon-Fri, 9am-6pm EST</p>
          </div>

          <div className="info-card">
            <h3>📍 Office</h3>
            <p>Marketing V8</p>
            <p>Rokaocin 4D</p>
            <p>83-200 Rokocin</p>
            <p>Poland</p>
            
          </div>

          <div className="info-card">
            <h3>🌐 Social Media</h3>
            <div className="social-links">
              <a href="#linkedin">LinkedIn</a>
              <a href="#twitter">Twitter</a>
              <a href="#facebook">Facebook</a>
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <ContactFormTwo />
        </div>
      </div>
    </div>
  );
}

export default Contact;
